export const IntegrationOnHoldClientAccessColumns = {
	model: [
		{
			label: 'Tracking System',
			key: 'trackingSystem',
		},
		{
			label: 'On Hold Reason',
			key: 'holdReasonId'
		},
		{
			label: 'Send To Client?',
			key: 'sendToClient'
		},
		{
			label: 'Receive From Client',
			key: 'receiveFromClient'
		},
	],

	formBuilderConfig: {
		trackingSystem: {
			DataType: 'Selector',
			DisplayText: 'Tracking System',
			Name: 'trackingSystem',
			UIControl: 'Dropdown',
		},
		holdReasonId: {
			DataType: 'Selector',
			DisplayText: 'On Hold Reason',
			Name: 'holdReasonId',
			UIControl: 'Dropdown',
		},
		sendToClient: {
			DataType: 'Boolean',
			SubDataType: 'checkbox',
			DisplayText: 'Send To Client?',
			Name: 'sendToClient',
			required: false,
			defaultValue: false,
			UIOptions: {
				showLabel: true,
				customTemplate: false,
			},
			options: [
				{label: 'No', value: false},
				{label: 'Yes', value: true}
			]
		},
		receiveFromClient: {
			DataType: 'Selector',
			DisplayText: 'Receive From Client',
			Name: 'receiveFromClient',
			UIControl: 'Dropdown',
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
}
